import script from "./CookiesOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiesOverlay.vue?vue&type=script&setup=true&lang=js"

import "./CookiesOverlay.vue?vue&type=style&index=0&id=6e4d617a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4d617a"]])

export default __exports__